import { OPEN_SMALL_MODAL } from '../actions/OpenSmallModal';
import { CLOSE_SMALL_MODAL } from '../actions/CloseSmallModal';

const initialState = {
  type: null,
  data: {},
  open: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_SMALL_MODAL:
      return {
        type: action.modalType,
        data: action.data,
        open: true,
      };
    case CLOSE_SMALL_MODAL:
      return initialState;
    default:
      return state;
  }
};
